import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { Donor } from "./OrderRequestsModel/Donor"

export interface GetDonorRequest {
  Identifier?: string
  IdentifierType?: number | string
  DonorID?: string
  CompanyID: number
  RegulatoryModeID: number
  LastName?: string
  EveningPhone?: string
  DayTimePhone?: string
  Mobile?: null
  DateOfBirth?: string
  isPortalAdmin?: boolean
}

export function SearchDonorGetObservable(parameters: GetDonorRequest): Observable<Donor[]> {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<Donor[]>("Workforceorder/SearchDonorInformationByIDV2", requestBody)
}

export function AdvanceSearchDonorGetObservable(parameters: GetDonorRequest): Observable<Donor[]> {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<Donor[]>("Workforceorder/AdvanceSearchDonorInformation", requestBody)
}